export default {
  UNSEEN: "UNSEEN",
  DISPLAYED: "DISPLAYED",
  DISMISSED: "DISMISSED",
};
